module.exports = __webpack_public_path__ + "static/img/tool_01.403f4da9.jpg";